// extracted by mini-css-extract-plugin
export default {"page":"CareerPage_page__pw8Tw","page__header":"CareerPage_page__header__mAlsG","page__title":"CareerPage_page__title__bE42q"};